<template>
    <span class="print-documents">
        <div v-if="!mailIsLoaded" class="loading-content-container d-flex justify-content-center">
            <csp-loading-indicator/>
        </div>
        <div v-else class="info-card editMode">
            <b-row>
                <csp-form-group-input
                    class="col-6 info-card-element"
                    :form="mailForm"
                    override-label="Absender Name"
                    property="fromName"
                    :required="true"
                    type="text"/>
                <csp-form-group-input
                    autocomplete="email"
                    class="col-6 info-card-element"
                    :form="mailForm"
                    override-label="Absender Email"
                    property="fromMail"
                    :required="true"
                    type="email"/>
            </b-row>
            <b-row>
                <csp-form-group-input
                    class="col-6 info-card-element"
                    :form="mailForm"
                    override-label="Empfänger Name"
                    property="toName"
                    type="text"/>
                <csp-form-group-input
                    autocomplete="email"
                    class="col-6 info-card-element"
                    :form="mailForm"
                    override-label="Empfänger Email"
                    property="toMail"
                    :required="true"
                    type="email"/>
            </b-row>
            <template v-if="hasInternalCopy">
                <hr>
                <b-row>
                    <csp-form-group-select-searchable
                        class="col-6 info-card-element"
                        :form="mailForm"
                        :options="internalCopyOptions"
                        override-label="Interne Kopie an"
                        property="internalCopy"/>
                </b-row>
            </template>
            <template v-if="hasDateReminder">
                <hr>
                <b-row>
                    <csp-form-group-datepicker
                        class="col-6 info-card-element"
                        :form="mailForm"
                        :max-date="null"
                        :min-date="dateNowAsString()"
                        override-label="Datum Wiedervorlage/Frist Vermerk"
                        property="dateReminder"/>
                </b-row>
            </template>
            <hr>
            <b-row>
                <div class="form-group col-12 info-card-element">
                    <additional-mail-recipients :form="additionalMailRecipientsForm"/>
                </div>
            </b-row>
            <hr>
            <b-row>
                <csp-form-group-input
                    class="col-12 info-card-element"
                    :form="mailForm"
                    override-label="Betreff"
                    property="subject"
                    :required="true"
                    type="text"/>
            </b-row>
            <hr>
            <b-row>
                <div class="form-group col-12 info-card-element">
                    <csp-form-group-ckeditor
                        :form="mailForm"
                        override-label="Nachricht"
                        property="mailMessage"/>
                </div>
            </b-row>
            <!--                        is this fine, or do i still need the form group without record-->
            <hr v-if="recordId">
            <b-row v-if="recordId">
                <div class="form-group col-12 info-card-element">
                    <csp-hide-for-group
                        :form="hideForGroupForm"
                        override-label="Sichtbarkeit"
                        property="hide"
                        :record-id="recordId"/>
                </div>
            </b-row>
            <hr>
            <b-row>
                <div class="form-group col-12 info-card-element">
                    <common-attachments :attachments="commonAttachments" :form="commonAttachmentsForm" :path="path"/>
                </div>
            </b-row>
            <b-row v-if="staticAttachments.length > 0">
                <div class="form-group col-12 info-card-element">
                    <static-attachments
                        :attachments="staticAttachments"
                        :default-check-attachments="defaultCheckStaticAttachments"
                        :form="staticAttachmentsForm"/>
                </div>
            </b-row>
            <b-row v-if="documentAttachments.length > 1">
                <div class="form-group col-12 info-card-element">
                    <document-attachments :attachments="documentAttachments" :form="documentAttachmentsForm"/>
                </div>
            </b-row>
            <div class="form-group text-right">
                <button class="btn btn-secondary" @click="$emit('cancel-mail')">
                    Abbrechen
                </button>
                <button class="btn btn-primary" @click="sendMail">
                    <span v-if="isUpdating" aria-hidden="true"
                        class="spinner-border spinner-border-sm" role="status"/>
                    Senden
                </button>
            </div>
        </div>
    </span>
</template>

<script>

    import '@desktop/scss/components/record/document-mail-modal.scss';
    import Container from '@services/Container';
    import Form from '@form/Form';
    import CommonAttachments from './mail/CommonAttachments.vue';
    import StaticAttachments from './mail/StaticAttachments.vue';
    import DocumentAttachments from './mail/DocumentAttachments.vue';
    import AdditionalMailRecipients from './mail/AdditionalMailRecipients.vue';
    import {dateNowAsString} from '@js/functions/date';
    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        components: {
            'common-attachments': CommonAttachments,
            'static-attachments': StaticAttachments,
            'document-attachments': DocumentAttachments,
            'additional-mail-recipients': AdditionalMailRecipients,
        },
        props: {
            defaultCheckStaticAttachments: {
                type: Boolean,
                default: false,
            },
            mailDocument: {
                type: Object,
                required: true,
            },
            path: {
                type: String,
                required: true,
            },
        },
        emits: ['cancel-mail', 'close-mail-modal', 'mail-sent', 'mail-validation-error'],
        data() {
            return {
                mailIsLoaded: false,
                mailForm: new Form({}),
                mailRawData: {},
                recordId: null,
                documentAttachmentsTypeData: null,
                isUpdating: false,
            }
        },
        computed: {
            hideForGroupForm() {
                return this.mailForm.getSubform('visibility');
            },
            commonAttachmentsForm() {
                return this.mailForm.getSubform('commonAttachments');
            },
            commonAttachments() {
                let commonAttachments = [];
                if (
                    Object.hasOwn(this.mailRawData, 'commonAttachments') &&
                    Array.isArray(this.mailRawData.commonAttachments.data.attributes)
                ) {
                    commonAttachments = this.mailRawData.commonAttachments.data.attributes;
                }
                return commonAttachments;
            },
            staticAttachmentsForm() {
                return this.mailForm.getSubform('staticAttachments');
            },
            staticAttachments() {
                let staticAttachments = [];
                if (
                    Object.hasOwn(this.mailRawData, 'staticAttachments') &&
                    Array.isArray(this.mailRawData.staticAttachments.data.attributes)
                ) {
                    staticAttachments = this.mailRawData.staticAttachments.data.attributes;
                }
                return staticAttachments;
            },
            documentAttachmentsForm() {
                return this.mailForm.getSubform('documentAttachments');
            },
            documentAttachments() {
                let documentAttachments = [];
                if (
                    Object.hasOwn(this.mailRawData, 'documentAttachments') &&
                    Array.isArray(this.mailRawData.documentAttachments.data.attributes)
                ) {
                    documentAttachments = this.mailRawData.documentAttachments.data.attributes;
                }
                return documentAttachments;
            },
            additionalMailRecipientsForm() {
                return this.mailForm.getSubform('additionalMailRecipients');
            },
            hasInternalCopy() {
                return this.internalCopyOptions.length > 0;
            },
            internalCopyOptions() {
                return Object.hasOwn(this.mailRawData, 'internalCopyOptions') ?
                    this.mailRawData.internalCopyOptions :
                    [];
            },
            hasDateReminder() {
                return Object.hasOwn(this.mailRawData, 'dateReminder');
            },
        },
        watch: {
            mailDocument: {
                handler(newMailDocument) {
                    if (newMailDocument) {
                        this.loadMailAndOpenMailModal()
                    }
                },
                immediate: true,
            },
        },
        mounted() {
            this.flashMessenger = container.getFlashMessenger();
        },
        methods: {
            dateNowAsString,
            loadMailAndOpenMailModal() {
                recordRepository.loadMailForm(
                    this.path
                ).then((data) => {
                    if (Object.hasOwn(data, 'mailValidationErrors')) {
                        this.$emit('mail-validation-error', data.mailValidationErrors);
                    }
                    this.recordId = parseInt(this.$route.params.recordId);
                    this.mailRawData = data.data.attributes;
                    this.mailForm.setData(data.data.attributes);
                    this.mailIsLoaded = true;

                    // store Attachment_Documents type data for later use in send
                    const documentAttachments = this.mailForm.getSubform('documentAttachments').getData();
                    if (Array.isArray(documentAttachments)) {
                        documentAttachments.forEach(attachment => {
                            if (Object.hasOwn(attachment, 'name') && attachment.name === 'Attachment_Documents') {
                                this.documentAttachmentsTypeData = attachment.value;
                            }
                        });
                    }
                })
            },
            sendMail() {
                this.isUpdating = true;
                const formData = new FormData();
                const mailData = this.mailForm.getData();

                // mail base data
                formData.append('fromName', mailData.fromName);
                formData.append('fromMail', mailData.fromMail);
                formData.append('toMail', mailData.toMail);
                formData.append('subject', mailData.subject);
                formData.append('mailMessage', mailData.mailMessage);
                if (this.hasInternalCopy && mailData.internalCopy !== null) {
                    formData.append('internalCopy', mailData.internalCopy);
                }
                if (this.hasDateReminder && mailData.dateReminder !== null) {
                    formData.append('dateReminder', mailData.dateReminder);
                }

                // visibility
                const visibility = this.mailForm.getSubform('visibility').getData();
                if (Object.hasOwn(visibility, 'hide')) {
                    visibility.hide.forEach(hide => {
                        formData.append('visibility[hide][]', hide);
                    })
                }

                // common attachments
                const commonAttachments = this.mailForm.getSubform('commonAttachments').getData();
                const ca = {};
                if (Array.isArray(commonAttachments)) {
                    commonAttachments.forEach(attachment => {
                        if (Object.hasOwn(attachment, 'checked') && attachment.checked) {
                            ca[attachment.name] = attachment.label;
                            formData.append('commonAttachments[' + attachment.checked + ']', 1);
                        }
                    });
                    formData.append('commonAttachments[Attached_Files]', JSON.stringify(
                        ca
                    ));
                }

                // static attachments
                const staticAttachments = this.mailForm.getSubform('staticAttachments').getData();
                if (Array.isArray(staticAttachments)) {
                    staticAttachments.forEach(attachment => {
                        if (Object.hasOwn(attachment, 'checked') && attachment.checked
                            && attachment.checked !== 'selectAll') {
                            formData.append('staticAttachments[' + attachment.checked + ']', 1);
                        }
                    });
                }

                // document attachments
                const documentAttachments = this.mailForm.getSubform('documentAttachments').getData();
                if (Array.isArray(documentAttachments)) {
                    documentAttachments.forEach(attachment => {
                        if (Object.hasOwn(attachment, 'checked') && attachment.checked) {
                            formData.append('documentAttachments[' + attachment.checked + ']', 1);
                        }
                    });
                    formData.append('documentAttachments[Attachment_Documents]', this.documentAttachmentsTypeData);
                }

                // additional mail recipients
                const additionalMailRecipients = this.mailForm.getSubform('additionalMailRecipients').getData();
                if (Array.isArray(additionalMailRecipients)) {
                    additionalMailRecipients.forEach((recipient, index) => {
                        if (recipient.mail !== '') {
                            formData.append('additionalMailRecipients[' + index + '][type]', recipient.type);
                            formData.append('additionalMailRecipients[' + index + '][name]', recipient.name);
                            formData.append('additionalMailRecipients[' + index + '][mail]', recipient.mail);
                        }
                    })
                }

                // sending and error handling
                return recordRepository.sendDocumentMail(this.path, formData).then(
                    () => {
                        this.flashMessenger.addSuccess('Die E-Mail wurde versandt');
                        this.$emit('close-mail-modal');
                        this.$emit('mail-sent');
                        this.isUpdating = false;
                    },
                    (error) => {
                        this.mailForm.setValidationErrors(error);
                        this.isUpdating = false;
                    }
                );
            },
        },
    }
</script>
